import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Typography,
  Pagination,
  Stack,
  TablePagination,
  TableSortLabel,
} from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DataStatusAlert from "../../../../AssetManagement/Health/DataAccuracy/UI_HelpersOf_DataAccuracy/DataStatusAlert_Helpers";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const ProcessLogsTable = ({ tableHeadings, rows }: Props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const headCells = Object.entries(tableHeadings);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <TableContainer className="BrandsTable">
        <Table aria-label="collapsible table" size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "run_iD" ? (
                          <>
                            <Link
                              to="#"
                              style={{
                                textDecoration: "underline",
                                color: "#9C27B0",
                              }}
                            >
                              <Typography color="secondary" fontSize="14px">
                                {row[key] ? row[key] : "N/A"}
                              </Typography>
                            </Link>
                          </>
                        ) : key === "brand_name" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "pod_name" ? (
                          <>
                            <Link
                              to="#"
                              style={{
                                textDecoration: "underline",
                                color: "#9C27B0",
                              }}
                            >
                              <Typography color="secondary" fontSize="14px">
                                {row[key] ? row[key] : "N/A"}
                              </Typography>
                            </Link>
                          </>
                        ) : key === "start_date" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "end_date" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "process_type" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "status" ? (
                          <DataStatusAlert status={row.status} />
                        ) : row[key] ? (
                          row[key]
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={rows?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                {
                  display: "none",
                },
              ".MuiTablePagination-actions": {
                display: "none",
              },
              ".MuiTablePagination-toolbar": {
                paddingLeft: "16px",
              },
            }}
          />
          <Pagination
            count={Math.ceil(rows?.length / rowsPerPage)}
            onChange={(_, value) => handleChangePage(null, value - 1)}
            showFirstButton
            showLastButton
            className="pagination-button"
            color="secondary"
            size="small"
            sx={{
              ".css-wjh20t-MuiPagination-ul": {
                justifyContent: "center",
              },
            }}
          />
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            classes={{
              displayedRows: "hidden-displayed-rows", // Apply the custom class
            }}
            sx={{
              ".MuiTablePagination-actions": {
                display: "none",
              },
              ".MuiTablePagination-input": {
                marginRight: "15px",
              },
            }}
          />
        </Stack>
      </TableContainer>
    </>
  );
};

export default ProcessLogsTable;
